import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { getStatusTagLabel, isStatusTag } from './index';
import { tagCloseIconContainer, tagRoot } from '../constants';
export var useTag = function useTag(_ref, ref) {
  var type = _ref.type,
      label = _ref.label,
      children = _ref.children,
      onClose = _ref.onClose,
      onDeselect = _ref.onDeselect,
      code = _ref.code,
      disabled = _ref.disabled,
      deleteOption = _ref.deleteOption,
      small = _ref.small,
      restRootProps = _objectWithoutProperties(_ref, ["type", "label", "children", "onClose", "onDeselect", "code", "disabled", "deleteOption", "small"]);

  var realLabel = label;

  if (isStatusTag(type)) {
    realLabel = getStatusTagLabel(type);
  }

  var content = children || realLabel;
  var onCloseButtonClick = useCallback(function (event) {
    if (disabled) {
      return;
    }

    event.stopPropagation();

    if (onClose) {
      onClose(event);
    }

    if (onDeselect) {
      onDeselect(code);
    }
  }, [onClose, onDeselect]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restRootProps), {}, {
      deleteOption: deleteOption,
      'data-testid': tagRoot,
      ref: ref,
      small: small,
      type: type,
      disabled: disabled
    }),
    tagCloseIconContainerProps: {
      deleteOption: deleteOption,
      small: small,
      onClick: onCloseButtonClick,
      disabled: disabled,
      type: type,
      tabIndex: 0,
      'data-testid': tagCloseIconContainer
    },
    tagTypographyProps: {
      deleteOption: deleteOption,
      smallVerticalPadding: small
    },
    disabled: disabled,
    deleteOption: deleteOption,
    type: type,
    content: content,
    onCloseButtonClick: onCloseButtonClick,
    small: small
  };
};